import { WindowService } from './../../services/window-dialogs/window.service';
import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../../app/services/modal-dialogs';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { SortBot } from '../../helpers/sort';
import { UpdateSuccessArray } from '@models/livehub/update.success';
import { LicenseManager } from 'app/managers/License.manager';
import { SubscribeToLicensesRequest } from '@models/ss-api/requests/subscribe.to.licenses.request';
import { LiveHubService } from '@services/livehub.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'update-commandcenter',
    templateUrl: './update.commandcenter.component.html',
    styleUrls: ['./update.commandcenter.component.scss']
})

export class UpdateCommandCenterComponent implements OnInit {
    IsBusy: boolean = false;

    UpdateLogs: UpdateSuccessArray;
    UpdateLogsFilter: string;

    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    lastRefreshed: Date = new Date(); // Initialize with current time

    autoLoadedLogs: number = 0;

    private updateSuccessSubscription: Subscription;

    constructor(private dialogService: DialogService, private gb: GlobalService, private api: ssApiService, private windowService: WindowService, private liveHub: LiveHubService) { }

    ngOnInit() {
        this.gb.SetPageTitle('Command Center');
        // this.IsBusy = true;
        this.LoadUpdateLogs();
        this.SubscribeToUpdates();
    }

    ngOnDestroy() {
        if (this.updateSuccessSubscription) {
            this.updateSuccessSubscription.unsubscribe();
        }
    } 

    SubscribeToUpdates(){
        let allLicenseKeys: Array<string> = ["00000-00000-00000"];

        var request = new SubscribeToLicensesRequest();
        request.VerboseUpdates = true;
        request.LicenseKeys = allLicenseKeys;

        this.liveHub.InvokeConnection('SubscribeToLicenses', request);    
        
        // Unsubscribe from previous subscription if it exists
        if (this.updateSuccessSubscription) {
            this.updateSuccessSubscription.unsubscribe();
        } 

        //Handle responses
        this.updateSuccessSubscription = this.liveHub.UpdateSuccess.subscribe(response => {
            console.log("USS", response);
            response.DynamicallyLoaded = true;
            this.UpdateLogs.unshift(response); // Add the new response to the first position            
        })
    }

    getDynamicallyLoadedCount(): number {
        return this.UpdateLogs ? this.UpdateLogs.filter(item => item.DynamicallyLoaded).length : 0;
    }

    paginateUpdateLogs(e) {
        // console.log("paginateSearch :", e);
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }
 
    onLicenseClick(license: string) {
        this.IsBusy = true;
        let manager = new LicenseManager()
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(license, true);
    }

    LoadUpdateLogs() {
        this.IsBusy = true;

        let disposable = this.api.GetLiveHubUpdateLogs(250).subscribe(response => {
            this.IsBusy = false;
            this.lastRefreshed = new Date(); // Update timestamp
            this.UpdateLogs = response.Data;
            console.log("cbm", this.UpdateLogs);
            disposable.unsubscribe();
        });
    }

    ClearData() {
        this.lastRefreshed = new Date(); // Update timestamp
        this.UpdateLogs.length = 0;
    } 

    SortBy( sortVar1: string, sortVar2: string = '' ) {
        this.UpdateLogs = SortBot.SortAuto( this.UpdateLogs, sortVar1, sortVar2);
    }

    onSearchTable(term) {
        this.UpdateLogsFilter = term;
    }

}
